package com.bikompanion.data.cache

import com.bikompanion.domain.BikeStation

/** Cached availability with the moment it was read, which is the point of storing it at all. */
data class StationsCacheEntry(
    val stations: List<BikeStation>,
    val updatedAtEpochMillis: Long,
)
